// RULES:
// 1. Base URLS do NOT have trailing '/'
// 1.1 Means paths should have leading '/'

export const configSettings = {
    siteName: 'Stan',
    siteUrl: process.env.SITE_URL || 'http://localhost:3000',

    // API Configuration
    apiUrl: process.env.NEXT_PUBLIC_API_PYTHON_BASE_URL,
    authApiUrl: process.env.NEXT_PUBLIC_API_AUTH_BASE_URL,
    informalApiUrl: process.env.NEXT_PUBLIC_INFORMAL_API_BASE_URL,

    // Environment
    environment: process.env.ENVIRONMENT,
    isDevelopment: !process.env.ENVIRONMENT || process.env.ENVIRONMENT === 'local',
    isProduction: process.env.ENVIRONMENT === 'production',

    // UI Configuration
    defaultTheme: 'light' as 'light' | 'dark' | 'system',

    // Domain settings
    noHttpsAdminDomain: process.env.NEXT_PUBLIC_DOMAIN_NO_PROTOCOL,
    adminDomain: process.env.NEXT_PUBLIC_DOMAIN_NO_PROTOCOL
        ? `https://${process.env.NEXT_PUBLIC_DOMAIN_NO_PROTOCOL}/`
        : undefined,

    noHttpsAdminLegacyDomain: process.env.NEXT_PUBLIC_LEGACY_DOMAIN_NO_PROTOCOL,
    legacyAdminDomain: process.env.NEXT_PUBLIC_LEGACY_DOMAIN_NO_PROTOCOL
        ? `http://${process.env.NEXT_PUBLIC_LEGACY_DOMAIN_NO_PROTOCOL}/`
        : undefined,
    noHttpsFrontDomain: process.env.NEXT_PUBLIC_FRONT_DOMAIN_NO_PROTOCOL,
    frontDomain: process.env.NEXT_PUBLIC_FRONT_DOMAIN_NO_PROTOCOL
        ? `https://${process.env.NEXT_PUBLIC_FRONT_DOMAIN_NO_PROTOCOL}/`
        : undefined,
    noHttpsLandingDomain: process.env.LANDING_DOMAIN_NO_PROTOCOL,
    landingDomain: process.env.LANDING_DOMAIN_NO_PROTOCOL
        ? `https://${process.env.LANDING_DOMAIN_NO_PROTOCOL}/`
        : undefined,

    // Payment processing
    stripeKey: process.env.NEXT_PUBLIC_STRIPE_KEY,
    stripePlatformKey: process.env.NEXT_PUBLIC_PLATFORM_STRIPE_KEY,

    // Analytics and tracking
    analyticsApi: process.env.NEXT_PUBLIC_ANALYTICS_API,
    zapierInviteLink: 'https://zapier.com/apps/stan-creator/integrations',
    sentryDsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    mouseflowAnalyticsTrackingCode: process.env.MOUSEFLOW_ANALYTICS_TRACKING_CODE || null,
    clarityTrackingCode: process.env.NEXT_PUBLIC_CLARITY_TRACKING_CODE,
    amplitudeAPIKey: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,

    // External service keys
    googleMapsApiKey: process.env.VITE_GOOGLE_MAPS_API_KEY,
    unsplashApiClientId: process.env.NEXT_PUBLIC_UNSPLASH_API_CLIENT_ID || null,
    captchaSiteKey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,

    assetsDomain: process.env.NEXT_PUBLIC_IMAGE_ASSETS,

    // AI and chat services
    chatAIApiUrl: process.env.CHAT_AI_API_BASE_URL,
    chatAIApiUrlV2: process.env.CHAT_AI_API_V2_BASE_URL,

    // Community features
    communityDomain: process.env.COMMUNITY_DOMAIN,
    communityApiUrl: process.env.NEXT_PUBLIC_COMMUNITY_API_BASE_URL,

    // Social media integration
    instagramClientId: process.env.NEXT_PUBLIC_INSTAGRAM_CLIENT_ID,
    instagramRedirectUri: process.env.NEXT_PUBLIC_INSTAGRAM_REDIRECT_URI,
};

// Type-safe config access
export type ConfigSettings = typeof configSettings;
